import * as React from "react"
import type { SVGProps } from "react"
const SvgEmailAddress = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M12 22.71a10 10 0 0 1-3.9-.78 10 10 0 0 1-3.17-2.14 10 10 0 0 1-2.14-3.18 10 10 0 0 1-.79-3.9q0-2.07.79-3.9a10 10 0 0 1 2.13-3.17Q6.28 4.29 8.1 3.5a10 10 0 0 1 3.9-.79q2.07 0 3.9.8a10 10 0 0 1 3.18 2.13q1.34 1.35 2.13 3.18a10 10 0 0 1 .79 3.9v1.45q0 1.48-1.01 2.5c-1.01 1.03-1.5 1.04-2.49 1.04a4 4 0 0 1-1.65-.37 3.5 3.5 0 0 1-1.3-1.07 5 5 0 0 1-1.64 1.08 5 5 0 0 1-1.91.37 4.8 4.8 0 0 1-3.54-1.47A4.8 4.8 0 0 1 7 12.71q0-2.07 1.46-3.53Q9.93 7.7 12 7.7c2.07 0 2.56.5 3.54 1.47A4.8 4.8 0 0 1 17 12.7v1.45q0 .66.43 1.1.42.45 1.07.45t1.08-.45.42-1.1V12.7q0-3.35-2.33-5.67A7.7 7.7 0 0 0 12 4.7q-3.34 0-5.67 2.33A7.7 7.7 0 0 0 4 12.7q0 3.36 2.33 5.68A7.7 7.7 0 0 0 12 20.7h4q.42 0 .71.3.3.28.29.7 0 .43-.29.72a1 1 0 0 1-.71.28zm0-7q1.25 0 2.13-.87A3 3 0 0 0 15 12.7q0-1.25-.87-2.12A3 3 0 0 0 12 9.7q-1.25 0-2.12.88A3 3 0 0 0 9 12.7q0 1.26.88 2.13a3 3 0 0 0 2.12.87" />
  </svg>
)
export default SvgEmailAddress
